import React, { useState, useRef } from 'react';
import { Button } from 'aha-components';
import { isMobile } from '@/biz/tool';
import BottomDrawer from './BottomDrawer';
import WebModal from './Modal';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import toast from 'react-hot-toast';
import axiosInstance from '@/apis/axiosInstance';
import { useTranslation } from 'react-i18next';

const ModalWithdrawThisCollaboration: React.FC<{}> = () => {
  const { t } = useTranslation();
  const [btnLoading, setBtnLoading] = useState(false);
  const submittingRef = useRef(false);
  const {
    showModalWithdrawThisCollaboration,
    setShowModalWithdrawThisCollaboration,
    setShowModalDealWithdrawn,
    withDrawOrderId
  } = useWebModalStore();

  const queryWithdraw = async () => {
    if (submittingRef.current || !withDrawOrderId) return;
    submittingRef.current = true;
    try {
      const orderId = withDrawOrderId;
      setBtnLoading(true);
      const { data } = await axiosInstance.post(`/order/${orderId}/withdraw`);
      if (data.code === 0) {
        setShowModalWithdrawThisCollaboration(false, '');
        setShowModalDealWithdrawn(true);
      } else {
        if (data.message) {
          toast.error(data.message);
        } else {
          toast.error(
            t('modal.withdraw.error', { defaultValue: 'Withdraw failed' })
          );
        }
      }
    } catch (error) {
      toast.error(
        error instanceof Error
          ? error.message
          : t('modal.withdraw.error', { defaultValue: 'Withdraw failed' })
      );
    } finally {
      submittingRef.current = false;
      setBtnLoading(false);
    }
  };

  const ModalContent = () => {
    return (
      <div className={`w-full flex flex-col items-center gap-6`}>
        <div
          className={`relative w-full flex flex-col items-center gap-6 
        `}
        >
          <div
            className={`overflow-auto flex flex-col gap-6 items-center
          ${isMobile() ? 'pb-20 pt-0' : ''}`}
          >
            <div className="self-stretch justify-start text-[#60646c] text-sm font-normal font-['Inter'] leading-normal mt-2">
              {t('modal.withdraw.confirmation_message', {
                defaultValue:
                  'Are you sure you want to withdraw from this brand deal? Since the brand has not responded within five business days, withdrawing will not impact your credibility on the platform.'
              })}
            </div>
          </div>
        </div>
        {/*  */}
        <div
          className={`bg-white w-full flex justify-end items-center gap-4 border-t border-solid border-[#e8e8ec] pt-4 
            ${isMobile() ? 'justify-center fixed bottom-0 left-0 pb-[calc(16px+env(safe-area-inset-bottom,0px))] px-4' : ''}
          `}
        >
          <Button
            onClick={() => setShowModalWithdrawThisCollaboration(false, '')}
            className={`${isMobile() ? '!w-full' : ''}`}
          >
            {t('modal.withdraw.cancel_btn', { defaultValue: 'Cancel' })}
          </Button>
          <Button
            disabled={btnLoading}
            onClick={() => {
              // setShowModalAnalysis(true);
              // setShowModalMissOut(false);
              queryWithdraw();
            }}
            type="primary"
            className={`${isMobile() ? '!w-full' : ''}`}
            loading={btnLoading}
          >
            {t('modal.withdraw.withdraw_btn', { defaultValue: 'Withdraw' })}
          </Button>
        </div>
      </div>
    );
  };
  return (
    <>
      {isMobile() ? (
        <BottomDrawer
          title={t('modal.withdraw.title', {
            defaultValue: 'Withdraw this collaboration'
          })}
          visible={showModalWithdrawThisCollaboration}
          handleClose={() => setShowModalWithdrawThisCollaboration(false, '')}
          isShowFooter={false}
          // isShowHeader={false}
          rootClassName="!z-[9999]"
        >
          <ModalContent />
        </BottomDrawer>
      ) : (
        <WebModal
          title={t('modal.withdraw.title', {
            defaultValue: 'Withdraw this collaboration'
          })}
          width={642}
          visible={showModalWithdrawThisCollaboration}
          handleClose={() => setShowModalWithdrawThisCollaboration(false, '')}
          isShowFooter={false}
          // isShowHeader={false}
        >
          <ModalContent />
        </WebModal>
      )}
    </>
  );
};

export default ModalWithdrawThisCollaboration;
